/**
 * TanStack Query client defaults (web/docs/data-layer.md §3). Lists/home stay
 * fresh for 60s; screens opt into longer stale times per query where the doc
 * calls for it (5min catalog detail, 0 after own-library mutations).
 */

import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false },
    },
  });
}
